import { Button, Checkbox, Col, Form, Input, InputNumber, Row, Select } from "antd"
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer"
import { DownArrowDraw, HaberForm, RightDrawerContainer } from "../../styledElements"
import { PaperMachineGradeSelect, PaperMachineQualitySelect } from "../../pageStyled"
import { MultiSelect } from "react-multi-select-component"
import { useEffect, useState } from "react"
import { useForm } from "antd/lib/form/Form"
import { getAllGradesForConfig, getGradeQualitiesForConfig } from "../../../Services/settingsServices"
import Iconmoon from "../../../Components/IconsFiles/icon"
import { getUnitData } from "../../../Services/measurementService"
import { addStockMatchingGroup, editStockMatchingGroup } from "../../../Services/stockMatchingServices"

const GroupSideBar = ({visible,onClose,editMode=false,initialData=null}) => {
    const [allGrades,setAllGrades] = useState([]);
    const [allQualities,setAllQualities] = useState([]);
    const [selectedQualities,setSelectedQualities] = useState(initialData?.qualities?.map((qual)=>({label:qual,value:qual}))||[]);
    const [lengthUnits,setLengthUnits] = useState([]);
    const [form] = useForm();

    useEffect(()=>{
        (async()=>{
            const grades = await getAllGradesForConfig();
            setAllGrades(grades.map((grade)=>({label:grade.name,value:grade.name})));

            if(editMode)
            {
                fetchQualities(initialData?.grade);
            }

            const response = await getUnitData();
            let options = response?.data?.units_management?.length?.data?.map(
                (unit)=>({label:unit,value:unit})
            )
            setLengthUnits(options);
        })();
    },[])

    const fetchQualities = async(grade) => {
        try{
            const qualities = await getGradeQualitiesForConfig(grade);
            setAllQualities(qualities.map((quality)=>({label:quality.name,value:quality.name})));
        }
        catch(e)
        {
            console.log(e);
        }
    }

    const removeQuality = (quality) => {
        const newQualities = selectedQualities.filter((qual)=>qual.value!=quality);
        setSelectedQualities(newQualities);
        form.setFieldsValue({qualities:newQualities.map((qual)=>qual.value)})
    }

    const handleFormSubmit = async(values) => {
        console.log(initialData,values)
        try{
            if(values?.accept_all_gsm)
            {
                values.gsm_lb=0;
                values.gsm_ub=0;
            }
            if(values?.accept_all_bf)
            {
                values.bf_lb=0;
                values.bf_ub=0;
            }
            if(values?.accept_all_bulk)
            {
                values.bulk_lb=0;
                values.bulk_ub=0;
            }
            if(values?.accept_all_moisture)
            {
                values.moisture_lb=0;
                values.moisture_ub=0;
            }
            const {reel_size_unit,sheet_size_unit,group_name,...rest} = values
            const body = {
                group_name: editMode?undefined:group_name,
                ...rest,
                units:{
                    reel_size_lb: reel_size_unit,
                    reel_size_ub: reel_size_unit,
                    sheet_size_lb: sheet_size_unit,
                    sheet_size_ub: sheet_size_unit,
                }
            }
            if(editMode)
            {
                await editStockMatchingGroup(initialData?.id,body);
            }
            else{
                await addStockMatchingGroup(body);
            }
            onClose();
        }
        catch(e)
        {
            console.log(e);
        }
    }

    return (
        <RightDrawerSidebar title={editMode?initialData?.group_name:"Add new group"} visible={visible} onClose={onClose}>
            <RightDrawerContainer>
                <HaberForm>
                    <div className="resetPassForm removePadLeft">
                        <Form
                            name="basic"
                            form={form}
                            onFinish={handleFormSubmit}
                            className="haberLogin haberSignup"
                            style={{marginBlockStart:"0px"}}
                            onValuesChange={(changedValues)=>{
                                console.log(changedValues)
                                if(changedValues.grade)
                                {
                                    form.setFieldsValue({"qualities":undefined});
                                    setSelectedQualities([]);
                                    fetchQualities(changedValues.grade);
                                }
                                if(changedValues.accept_all_gsm)
                                {
                                    form.setFieldsValue({gsm_lb:undefined,gsm_ub:undefined});
                                }
                                if(changedValues.accept_all_bf)
                                {
                                    form.setFieldsValue({bf_lb:undefined,bf_ub:undefined})
                                }
                                if(changedValues.accept_all_bulk)
                                {
                                    form.setFieldsValue({bulk_lb:undefined,bulk_ub:undefined});
                                }
                                if(changedValues.accept_all_moisture)
                                {
                                    form.setFieldsValue({moisture_lb:undefined,moisture_ub:undefined});
                                }
                            }}
                            initialValues={initialData}
                        >
                            <div className="drawerField">
                                <div className="titleWithText">
                                    <h5>Group name</h5>
                                    <p>Group will be identified with this name</p>
                                </div>
                                <Form.Item
                                    name={"group_name"}
                                    rules={[
                                        {
                                            required: true,
                                            message: "This field is required!"
                                        }
                                    ]}
                                >
                                    <Input disabled={editMode} placeholder="Enter name"/>
                                </Form.Item>
                            </div>
                            <div className="drawerField">
                                <div className="titleWithText">
                                    <h5>Type</h5>
                                    <p>Type of the group</p>
                                </div>
                                <Form.Item
                                    name={"type"}
                                    rules={[
                                        {
                                            required: true,
                                            message: "This field is required!"
                                        }
                                    ]}
                                    initialValue={"reel"}
                                >
                                    <Select
                                        placeholder="Select Type" 
                                        options={[
                                            {label:"Reel",value:"reel"},
                                            {label:"Sheet",value:"sheet"}
                                        ]}
                                        suffixIcon={<DownArrowDraw/>}
                                    />
                                </Form.Item>
                            </div>
                            <div className="drawerField">
                                <div className="titleWithText">
                                    <h5>Grade</h5>
                                    <p>Grade of the group</p>
                                </div>
                                <Form.Item
                                    name={"grade"}
                                    rules={[
                                        {
                                            required: true,
                                            message: "This field is required!"
                                        }
                                    ]}
                                >
                                    <Select
                                        placeholder="Select Grade" 
                                        options={allGrades}
                                        suffixIcon={<DownArrowDraw/>}
                                    />
                                </Form.Item>
                            </div>
                            <div className="drawerField">
                                <div className="titleWithText">
                                    <h5>Qualities</h5>
                                    <p>Similar Qualities can be selected here</p>
                                </div>
                                <Form.Item
                                    name={"qualities"}
                                    rules={[
                                        {
                                            required: true,
                                            message: "This field is required!"
                                        }
                                    ]}
                                >
                                    <PaperMachineQualitySelect>
                                        <MultiSelect
                                            labelledBy="Select Qualities"
                                            options={allQualities}
                                            value={selectedQualities}
                                            onChange={(e)=>{
                                                setSelectedQualities(e)
                                                form.setFieldsValue({qualities:e.map((quality)=>(quality.value))})
                                            }}
                                            disableSearch
                                        />
                                    </PaperMachineQualitySelect>
                                    <PaperMachineGradeSelect>
                                        <div className="mainMachineGrade" style={{marginBlockStart:"10px"}}>
                                            {selectedQualities?.map((quality)=>(
                                                <span className="MachineGradeSelect-active">
                                                    {quality.label}
                                                    <Button 
                                                        className="textTypeBtn textBtnIcon paperButtonBg"
                                                        onClick={()=>removeQuality(quality.value)}
                                                    >
                                                        <Iconmoon
                                                            icon="wrong"
                                                            size={14}
                                                            color="#EA655B"
                                                        />
                                                    </Button>
                                                </span>
                                            ))}
                                        </div>
                                    </PaperMachineGradeSelect>
                                </Form.Item>
                            </div>
                            <div className="drawerField">
                                <div className="titleWithText">
                                    <h5>GSM tolerance</h5>
                                    <p>Set GSM tolerance applicable</p>
                                </div>
                                <Row gutter={4}>
                                    <Col span={12}>
                                        <Form.Item dependencies={["accept_all_gsm"]}>
                                            {({getFieldValue})=>(
                                                <Form.Item
                                                    name={"gsm_lb"}
                                                    normalize={(value) => {
                            if (value === '' || value === null || value === undefined) return value;

                            const num = value.endsWith(".")?value:parseFloat(value);
                            return isNaN(num) ? value : num;
                          }}
                                                    rules={[
                                                        {
                                                            required: !getFieldValue("accept_all_gsm"),
                                                            message:"This field is required!"
                                                        },
                                                        {
                                                            pattern: /^(?:\d+|\d*\.\d+)$/,
                                                            message: "Only non-negative decimal numbers are allowed!"
                                                        }
                                                    ]}
                                                >
                                                    <Input placeholder={"LB"} disabled={getFieldValue("accept_all_gsm")}/>
                                                </Form.Item>
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item dependencies={["accept_all_gsm"]}>
                                            {({getFieldValue})=>(
                                                <Form.Item
                                                    name={"gsm_ub"}
                                                    normalize={(value) => {
                                                        if (value === '' || value === null || value === undefined) return value;

                                                        const num = value.endsWith(".")?value:parseFloat(value);
                                                        return isNaN(num) ? value : num;
                                                    }}
                                                    rules={[
                                                        {
                                                            required: !getFieldValue("accept_all_gsm"),
                                                            message:"This field is required!"
                                                        },
                                                        {
                                                            pattern: /^(?:\d+|\d*\.\d+)$/,
                                                            message: "Only non-negative decimal numbers are allowed!"
                                                        }
                                                    ]}
                                                >
                                                    <Input placeholder={"UB"} disabled={getFieldValue("accept_all_gsm")}/>
                                                </Form.Item>
                                            )}
                                        </Form.Item>
                                        
                                    </Col>
                                </Row>
                                <div className="titleWithText" style={{marginBlockStart:"-24px"}}>
                                    <Form.Item
                                        name={"accept_all_gsm"}
                                        valuePropName="checked"
                                    >
                                        <Checkbox><p>No tolerance restriction (Accept all values)</p></Checkbox>
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="drawerField">
                                <div className="titleWithText">
                                    <h5>Bulk tolerance</h5>
                                    <p>Set Bulk tolerance applicable</p>
                                </div>
                                <Row gutter={4}>
                                    <Col span={12}>
                                        <Form.Item dependencies={["accept_all_bulk"]}>
                                            {({getFieldValue})=>(
                                                <Form.Item
                                                    name={"bulk_lb"}
                                                    normalize={(value) => {
                                                        if (value === '' || value === null || value === undefined) return value;

                                                        const num = value.endsWith(".")?value:parseFloat(value);
                                                        return isNaN(num) ? value : num;
                                                    }}
                                                    rules={[
                                                        {
                                                            required: !getFieldValue("accept_all_bulk"),
                                                            message:"This field is required!"
                                                        },
                                                        {
                                                            pattern: /^(?:\d+|\d*\.\d+)$/,
                                                            message: "Only non-negative decimal numbers are allowed!"
                                                        }
                                                    ]}
                                                >
                                                    <Input placeholder={"LB"} disabled={getFieldValue("accept_all_bulk")}/>
                                                </Form.Item>
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item dependencies={["accept_all_bulk"]}>
                                            {({getFieldValue})=>(
                                                <Form.Item
                                                    name={"bulk_ub"}
                                                    normalize={(value) => {
                                                        if (value === '' || value === null || value === undefined) return value;

                                                        const num = value.endsWith(".")?value:parseFloat(value);
                                                        return isNaN(num) ? value : num;
                                                    }}
                                                    rules={[
                                                        {
                                                            required: !getFieldValue("accept_all_bulk"),
                                                            message:"This field is required!"
                                                        },
                                                        {
                                                            pattern: /^(?:\d+|\d*\.\d+)$/,
                                                            message: "Only non-negative decimal numbers are allowed!"
                                                        }
                                                    ]}
                                                >
                                                    <Input placeholder={"UB"} disabled={getFieldValue("accept_all_bulk")}/>
                                                </Form.Item>
                                            )}
                                        </Form.Item>
                                        
                                    </Col>
                                </Row>
                                <div className="titleWithText" style={{marginBlockStart:"-24px"}}>
                                    <Form.Item
                                        name={"accept_all_bulk"}
                                        valuePropName="checked"
                                    >
                                        <Checkbox><p>No tolerance restriction (Accept all values)</p></Checkbox>
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="drawerField">
                                <div className="titleWithText">
                                    <h5>BF tolerance</h5>
                                    <p>Set BF tolerance applicable</p>
                                </div>
                                <Row gutter={4}>
                                    <Col span={12}>
                                        <Form.Item dependencies={["accept_all_bf"]}>
                                            {({getFieldValue})=>(
                                                <Form.Item
                                                    name={"bf_lb"}
                                                    normalize={(value) => {
                                                        if (value === '' || value === null || value === undefined) return value;

                                                        const num = value.endsWith(".")?value:parseFloat(value);
                                                        return isNaN(num) ? value : num;
                                                    }}
                                                    rules={[
                                                        {
                                                            required: !getFieldValue("accept_all_bf"),
                                                            message:"This field is required!"
                                                        },
                                                        {
                                                            pattern: /^(?:\d+|\d*\.\d+)$/,
                                                            message: "Only non-negative decimal numbers are allowed!"
                                                        }
                                                    ]}
                                                >
                                                    <Input placeholder={"LB"} disabled={getFieldValue("accept_all_bf")}/>
                                                </Form.Item>
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item dependencies={["accept_all_bf"]}>
                                            {({getFieldValue})=>(
                                                <Form.Item
                                                    name={"bf_ub"}
                                                    normalize={(value) => {
                                                        if (value === '' || value === null || value === undefined) return value;

                                                        const num = value.endsWith(".")?value:parseFloat(value);
                                                        return isNaN(num) ? value : num;
                                                    }}
                                                    rules={[
                                                        {
                                                            required: !getFieldValue("accept_all_bf"),
                                                            message:"This field is required!"
                                                        },
                                                        {
                                                            pattern: /^(?:\d+|\d*\.\d+)$/,
                                                            message: "Only non-negative decimal numbers are allowed!"
                                                        }
                                                    ]}
                                                >
                                                    <Input placeholder={"UB"} disabled={getFieldValue("accept_all_bf")}/>
                                                </Form.Item>
                                            )}
                                        </Form.Item>
                                        
                                    </Col>
                                </Row>
                                <div className="titleWithText" style={{marginBlockStart:"-24px"}}>
                                    <Form.Item
                                        name={"accept_all_bf"}
                                        valuePropName="checked"
                                    >
                                        <Checkbox><p>No tolerance restriction (Accept all values)</p></Checkbox>
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="drawerField">
                                <div className="titleWithText">
                                    <h5>Moisture tolerance</h5>
                                    <p>Set Moisture tolerance applicable</p>
                                </div>
                                <Row gutter={4}>
                                    <Col span={12}>
                                        <Form.Item dependencies={["accept_all_moisture"]}>
                                            {({getFieldValue})=>(
                                                <Form.Item
                                                    name={"moisture_lb"}
                                                    normalize={(value) => {
                                                        if (value === '' || value === null || value === undefined) return value;

                                                        const num = value.endsWith(".")?value:parseFloat(value);
                                                        return isNaN(num) ? value : num;
                                                    }}
                                                    rules={[
                                                        {
                                                            required: !getFieldValue("accept_all_moisture"),
                                                            message:"This field is required!"
                                                        },
                                                        {
                                                            pattern: /^(?:\d+|\d*\.\d+)$/,
                                                            message: "Only non-negative decimal numbers are allowed!"
                                                        }
                                                    ]}
                                                >
                                                    <Input placeholder={"LB"} disabled={getFieldValue("accept_all_moisture")}/>
                                                </Form.Item>
                                            )}
                                        </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                        <Form.Item dependencies={["accept_all_moisture"]}>
                                            {({getFieldValue})=>(
                                                <Form.Item
                                                    name={"moisture_ub"}
                                                    normalize={(value) => {
                                                        if (value === '' || value === null || value === undefined) return value;

                                                        const num = value.endsWith(".")?value:parseFloat(value);
                                                        return isNaN(num) ? value : num;
                                                    }}
                                                    rules={[
                                                        {
                                                            required: !getFieldValue("accept_all_moisture"),
                                                            message:"This field is required!"
                                                        },
                                                        {
                                                            pattern: /^(?:\d+|\d*\.\d+)$/,
                                                            message: "Only non-negative decimal numbers are allowed!"
                                                        }
                                                    ]}
                                                >
                                                    <Input placeholder={"UB"} disabled={getFieldValue("accept_all_moisture")}/>
                                                </Form.Item>
                                            )}
                                        </Form.Item>
                                        
                                    </Col>
                                </Row>
                                <div className="titleWithText" style={{marginBlockStart:"-24px"}}>
                                    <Form.Item
                                        name={"accept_all_moisture"}
                                        valuePropName="checked"
                                    >
                                        <Checkbox><p>No tolerance restriction (Accept all values)</p></Checkbox>
                                    </Form.Item>
                                </div>
                            </div>
                            <div className="drawerField">
                                <Form.Item dependencies={["type"]}>
                                    {({getFieldValue})=>{
                                        const type = getFieldValue("type")
                                        return (<>
                                            <div className="titleWithText">
                                                <h5>{type == "reel"?"Reel ":"Sheet "}Size tolerance</h5>
                                                <p>Set{type == "reel"?" Reel ":" Sheet "} Size tolerance applicable</p>
                                            </div>
                                            <Row gutter={4}>
                                                <Col span={9}>
                                                    <Form.Item
                                                        name={`${type}_size_lb`}
                                                        normalize={(value) => {
                                                            if (value === '' || value === null || value === undefined) return value;

                                                            const num = value.endsWith(".")?value:parseFloat(value);
                                                            return isNaN(num) ? value : num;
                                                        }}
                                                        rules={[
                                                            {
                                                                required:true,
                                                                message:"This field is required!"
                                                            },
                                                            {
                                                                pattern: /^(?:\d+|\d*\.\d+)$/,
                                                                message: "Only non-negative decimal numbers are allowed!"
                                                            }
                                                        ]}
                                                    >
                                                        <Input placeholder={"LB"}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={9}>
                                                    <Form.Item
                                                        name={`${type}_size_ub`}
                                                        normalize={(value) => {
                                                            if (value === '' || value === null || value === undefined) return value;

                                                            const num = value.endsWith(".")?value:parseFloat(value);
                                                            return isNaN(num) ? value : num;
                                                        }}
                                                        rules={[
                                                            {
                                                                required:true,
                                                                message:"This field is required!"
                                                            },
                                                            {
                                                                pattern: /^(?:\d+|\d*\.\d+)$/,
                                                                message: "Only non-negative decimal numbers are allowed!"
                                                            }
                                                        ]}
                                                    >
                                                        <Input placeholder={"UB"}/>
                                                    </Form.Item>
                                                </Col>
                                                <Col span={6}>
                                                    <Form.Item
                                                        name={`${type}_size_unit`}
                                                        rules={[
                                                            {
                                                                required: true,
                                                                message: "This field is required!"
                                                            }
                                                        ]}
                                                    >
                                                        <Select 
                                                            placeholder={"Unit"} 
                                                            options={lengthUnits}
                                                            suffixIcon={<DownArrowDraw/>} 
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                        </>)
                                    }}
                                </Form.Item>
                            </div>
                            <div className="fixedBtm buttonFlex">
                                <Button
                                    className="themeBtn"
                                    onClick={()=>{
                                        form.submit();
                                    }}
                                >
                                    <Iconmoon icon={"addcircle"} color="#ffffff" size={16}/>
                                    Save Changes
                                </Button>
                                <Button
                                    className="themeBtn noBg"
                                    onClick={onClose}
                                >
                                    <Iconmoon icon={"delete"} color="#ea655b"  size={16}/>
                                    Cancel
                                </Button>
                            </div>
                        </Form>
                    </div>
                </HaberForm>
            </RightDrawerContainer>
        </RightDrawerSidebar>
    )
}

export default GroupSideBar;